import React, { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { Box, BoxProps, Theme, styled } from '@mui/material';
import CardHeader from './CardHeader';

interface CustomComtainProps extends BoxProps {
  arrow?: string;
}

const Container = styled(Box)<CustomComtainProps>(
  ({ theme, arrow = 'false' }: { theme: Theme; arrow?: string }) => ({
    position: 'relative',
    borderRadius: '3px',
    margin: '20px',
    '&::after': {
      display: arrow === 'true' ? 'block' : 'none',
      content: '""',
      position: 'absolute',
      top: '50%',
      right: '-20px',
      width: 0,
      height: 0,
      border: '20px solid transparent',
      borderLeftColor: theme.palette.secondary.light,
      borderRight: 0,
      marginTop: '-10px',
    },
  }),
);

const CardContent = styled(Box)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

interface Props {
  children?: React.ReactNode;
  bgcolor?: string;
  customStyle?: BoxProps;
  title?: string;
  iconOn?: boolean;
  iconCenter?: boolean;
  iconColor?: string;
  headerBGColor?: string;
  hasArrow?: boolean;
  iconName?: string;
}

const CardContainer: FC<Props> = observer(props => {
  const {
    children,
    customStyle,
    hasArrow,
    title,
    iconCenter,
    iconOn,
    bgcolor,
    iconColor,
    headerBGColor,
    iconName,
  } = props;

  return (
    <Container
      bgcolor={bgcolor || 'secondary.light'}
      {...customStyle}
      arrow={hasArrow?.toString()}
    >
      <CardHeader
        title={title || ''}
        iconOn={iconOn}
        iconCenter={iconCenter}
        iconColor={iconColor}
        bgcolor={headerBGColor}
        iconName={iconName}
      />
      <CardContent>{children}</CardContent>
    </Container>
  );
});

export default CardContainer;
